import { Tooltip } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomNavLink from "./CustomNavLink";
import MenuButton from "./MenuButton";
import MenuPopover from "./MenuPopover";
import PeriodAfficheePopover from "./PeriodAfficheePopover";
import SynthesePopover from "./SynthesePopover";

const NavButton = ({
  id,
  route,
  onClick,
  name,
  icon,
  isNavButton,
  arrowIcon,
  label,
  hasDivider,
  isSubNav,
  background,
  isSwitch,
  isDatePicker,
  handleMonthChange,
  selectedMonthRange,
  subItems,
  disabled,
  isPopover,
  mode,
}) => {
  const helpButton = name === "Besoin d’aide ?";
  const modeButton = name === "Trésorerie";
  const isBudgetButton = name === "Afficher un budget prev.";

  const { isSidebarClosed, mode: layoutMode } = useSelector(
    (state) => state.layout
  );
  const location = useLocation();
  const effectiveMode = mode || layoutMode;
  const isListingView = location.pathname.includes("listing");
  const isGraphView = location.pathname.includes("graph");
  const isBudgetDisabled =
    isBudgetButton &&
    (disabled ||
      effectiveMode === "treso" ||
      isListingView ||
      isGraphView);

  let buttonClassName = "button nav-link";
  if (helpButton) {
    buttonClassName += " config-buttons";
  } else {
    buttonClassName += disabled || isBudgetDisabled ? " disabled" : "";
  }

  let buttonName;
  if (name === "Afficher la synthèse") {
    if (effectiveMode === "compta") {
      buttonName = "Afficher une synthèse du résultat ";
    } else {
      buttonName = "Afficher une synthèse de trésorerie";
    }
  } else {
    buttonName = name;
  }

  let title = null;

  if (helpButton) {
    title = (
      <div>
        {isSidebarClosed && (
          <>
            Besoin d&apos;aide:
            <br />
          </>
        )}
        Consultez la page :
        <br />
        <a
          href="https://tresovista.com/demos-tutos"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          https://tresovista.com/demos-tutos
        </a>
        <br />
        , ou contactez-nous via :
        <br />
        <a
          href="mailto:tresovista@tresovista.com"
          onClick={(e) => e.stopPropagation()}
        >
          tresovista@tresovista.com
        </a>
      </div>
    );
  } else if (name === "Afficher la synthèse") {
    if (isListingView) {
      title = `Pour afficher la synthèse, vous devez passer en vue "Catégories"`;
    } else {
      title = isSidebarClosed ? (
        <div>
          Afficher une synthèse{" "}
          {effectiveMode === "compta" ? "du résultat " : "de trésorerie"}
        </div>
      ) : null;
    }
  } else if (isBudgetButton) {
    if (isBudgetDisabled) {
      title = (
        <div>
          Pour afficher un budget prévisionnel, vous devez passer en mode
          &quot;Résultat / Budget &quot; ET en vue &quot;Catégories&quot;
        </div>
      );
    } else if (effectiveMode === "compta") {
      title = <div>Afficher un budget prev</div>;
    }
  }

  let dividerClassName;

  if (effectiveMode === "treso") {
    dividerClassName = "treso-divider";
  } else {
    dividerClassName = "compta-divider";
  }

  let content;
  if (isNavButton) {
    content = (
      <CustomNavLink
        key={id}
        route={route}
        name={name}
        label={label}
        arrowIcon={arrowIcon}
        icon={icon}
        onClick={onClick}
        background={background}
        isSwitch={isSwitch}
        subItems={subItems}
        isPopover={isPopover}
        modeButton={modeButton}
      />
    );
  } else if (isPopover) {
    content = (
      <MenuPopover
        isPopover={isPopover}
        isSubNav={isSubNav}
        icon={icon}
        label={label}
        background={background}
        name={name}
        subItems={subItems}
      />
    );
  } else if (isSubNav) {
    content = (
      <>
        <CustomNavLink
          name={name}
          label={label}
          icon={icon}
          route={route}
          onClick={onClick}
          background={background}
          isSubNav={isSubNav}
          className={` button nav-link `}
          isSwitch={isSwitch}
        />
      </>
    );
  } else if (isDatePicker) {
    content = (
      <PeriodAfficheePopover
        selectedMonthRange={selectedMonthRange}
        handleMonthChange={handleMonthChange}
        hasDivider={hasDivider}
        mode={mode}
        isSidebarClosed={isSidebarClosed}
      />
    );
  } else if (name === "Afficher la synthèse") {
    content = (
      <SynthesePopover
        mode={mode}
        isSidebarClosed={isSidebarClosed}
        buttonName={buttonName}
      />
    );
  } else {
    content = (
      <>
        <Tooltip
          mouseLeaveDelay={0.3}
          mouseEnterDelay={0.8}
          trigger="hover"
          title={title}
          destroyTooltipOnHide
          getPopupContainer={() => document.body}
        >
          <span className="sidebar-nav-tooltip-anchor">
            <MenuButton
              key={id}
              name={buttonName}
              handleSubmit={(e) => {
                if (disabled || isBudgetDisabled) {
                  e.preventDefault();
                  return;
                }
                onClick(name);
                e.preventDefault();
              }}
              className={buttonClassName}
              primaryIcon={icon}
              secondaryIcon={arrowIcon}
              disabled={disabled || isBudgetDisabled}
            />
          </span>
        </Tooltip>
        {hasDivider && <div className={`divider ${dividerClassName}`}></div>}
      </>
    );
  }

  return content;
};
export default NavButton;
